
import { LogicalExpressionDecoder } from '../../logic/LogicalExpressionParser';
import { isNull } from '../../util/TypeUtil';
import VariableMutation from '../content/VariableMutation';

export default class Solver {
    constructor() {
        this.reset();
    }

    reset() {
        this._variables = {};
    }

    getState() {
        return this._variables;
    }

    setState(vars) {
        this._variables = vars;
    }

    solve(variable) {
        //console.debug(`SOLVER: solving ${variable}`);
        if (!isNull(this._variables[variable])) {
            return this._variables[variable];
        } else {
            return false;
        }
    }

    solveExpression(expression) {
        const decoder = new LogicalExpressionDecoder(expression);

        if (decoder.value.solve !== null) {
            return decoder.value.solve(this.solve.bind(this));
        } else {
            return decoder.value.evaluateNumber(this.solve.bind(this));
        }
    }

    setVariable(variable, value, operator) {
        if (isNull(operator))
            operator = VariableMutation.SET;

        let operatorTxt = "SET";
        switch (operator) {
            case VariableMutation.SET:
                operatorTxt = "SET";
                break;
            case VariableMutation.ADD:
                operatorTxt = "ADD";
                break;
            case VariableMutation.SUBTRACT:
                operatorTxt = "SUBTRACT";
                break;
            case VariableMutation.MULTIPLY:
                operatorTxt = "MULTIPLY";
                break;
            case VariableMutation.DIVIDE:
                operatorTxt = "DIVIDE";
                break;
        }

        console.log(`SOLVER: VARIABLE ${variable}, ${operatorTxt} ${value}`);

        if (!this._variables[variable]) this._variables[variable] = 0;

        switch (operator) {
            case VariableMutation.SET:
                this._variables[variable] = value;
                break;

            case VariableMutation.ADD:
                this._variables[variable] += value;
                break;

            case VariableMutation.SUBTRACT:
                this._variables[variable] -= value;
                break;

            case VariableMutation.MULTIPLY:
                this._variables[variable] *= value;
                break;

            case VariableMutation.DIVIDE:
                this._variables[variable] /= value;
                break;
        }
        //
        return this._variables[variable];
    }

    hasVariable(variable) {
        return this._variables.hasOwnProperty(variable);
    }

    getVariable(variable) {
        return this._variables[variable];
    }

    removeVariable(variable) {
        if (this.hasVariable(variable)) {
            delete this._variables[variable];
            return true;
        }
        return false;
    }
}
